import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { displayOutsideComponents, hideOutsideComponents } from '../../../utils/helpers'
import SelectVehicleStep from './SelectVehicleStep/SelectVehicleStep'
import AccessoriesStep from './AccessoriesStep/AccessoriesStep';

function VehicleAccessories({ formExtraParams }) {
  const { introductionText, initStepTopContents, language } = formExtraParams;
  const [currentStep, setCurrentStep] = useState(1);
  const [accessoriesData, setAccessoriesData] = useState(null);

  useEffect(() => {
    if (currentStep === 1) {
      displayOutsideComponents(initStepTopContents)
    } else {
      hideOutsideComponents(initStepTopContents)
    }
  }, [currentStep])

  return (
    <div className="mz-vehicle-accessories">
      <div className="mz-vehicle-accessories__inner mz-page-top" data-current-step={currentStep}>
        {
          currentStep === 1 && (
            <SelectVehicleStep
              introductionText={introductionText}
              language={language}
              setCurrentStep={setCurrentStep}
              setAccessoriesData={setAccessoriesData}
            />
          )
        }
        {
          currentStep === 2 && (
            <AccessoriesStep
              accessoriesData={accessoriesData}
              setCurrentStep={setCurrentStep}
              language={language}
            />
          )
        }
      </div>
    </div>
  )
}

VehicleAccessories.propTypes = {
  formExtraParams: PropTypes.object.isRequired
}

export default VehicleAccessories